/**
 * Recently viewed component
 * 
 * @module recently-viewed
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'recently-viewed';

if(!customElements.get(customElements.component)) {

    class recentlyViewed extends HTMLElement {

        /**
         * Recently viewed web component
         * 
         * @constructor
         */
        constructor() {

            super();

            this.numberOfProducts = 8;

            this.currentProductHandle = this.dataset.rvProductHandle || "";

            if(this.currentProductHandle !== ""){
                this.setRecentlyViewedProduct();
            }

            this.render();

            this.initSlider();

            this.displayComponent();
            
        }

        /**
        * Render component in the DOM
        * 
        * @returns {undefined}
        */
        render() {

            let productGridhtml = "";

            this.localData = JSON.parse(localStorage.getItem(`recentlyViewedProduct-${window.theme.enviroment}`) || []);

            this.localData.forEach(productHandle => {

                if(productHandle !== this.currentProductHandle){
                    productGridhtml = productGridhtml + `<div class="swiper-slide"><product-card 
                                                                data-handle="${productHandle}"
                                                                data-product-badge-best-seller-value-tag="${this.dataset.recentlyViewedBadgeBestSellerValueTag}"
                                                                data-product-badge-on-sale-value-tag="${this.dataset.recentlyViewedBadgeOnSaleValueTag}"
                                                                data-product-badge-new-value-tag="${this.dataset.recentlyViewedBadgeNewValueTag}"
                                                                data-product-badge-jump-line="${this.dataset.recentlyViewedBadgeJumpLine}"
                                                                ></product-card></div>`;
                }

            });

            this.querySelector('[recently-viewed-swiper-wrapper]'). innerHTML = productGridhtml;

        }

        /**
         * Set Recently Viewed Product
         * 
         * @returns {undefined}
         */
        setRecentlyViewedProduct() {

            let productList = [];

            let oldProductData = [];

            let localData = localStorage.getItem(`recentlyViewedProduct-${window.theme.enviroment}`);
            
            if (localData === null) {

                productList.push(this.currentProductHandle);

            }else{

                oldProductData = JSON.parse(localData);

                if(oldProductData.length > (this.numberOfProducts - 1)){
                    oldProductData.shift();
                }

                if(oldProductData.includes(this.currentProductHandle)){
                    oldProductData = oldProductData.filter( (returnableObjects) => {
                        return returnableObjects !== this.currentProductHandle;
                    });
                }

                productList.push(this.currentProductHandle, ...oldProductData);
            }
            
            let productDataString = JSON.stringify(productList);
            localStorage.setItem(`recentlyViewedProduct-${window.theme.enviroment}`, productDataString);

        }


        /**
         * Init slider.
         * 
         * @returns {undefined}
        */
        initSlider() {

            this.swiper = this.querySelector('[data-swiper]');

            const swiperMediaPagination = this.querySelector('.swiper-pagination');

            let defaultOptions = {
                    preloadImages: true,
                    lazy: {
                    loadPrevNext: true,
                },
                pagination: {
                    el: swiperMediaPagination,
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-recently-viewed-button-next',
                    prevEl: '.swiper-recently-viewed-button-prev',
                },
                on: {
                    afterInit: swiper => {

                        setTimeout(() => {
                            swiper.slides.forEach( (slide, index) => {
                                let productCard = slide.querySelector('product-card');
                                if(productCard && productCard.dataset.ready == "false"){
                                    swiper.removeSlide(index);
                                }
                            })
                        }, 300);

                    }                    
                }
            }

            let options = (this.dataset.options) ? JSON.parse(this.dataset.options) : {};

            this.options = {...defaultOptions, ...options};

            this.slider = new Swiper(this.swiper, this.options);

        }

        /**
         * Display Component validation.
         * 
         * @returns {undefined}
        */
        displayComponent() {
            if(this.localData.length > 0){

                if((this.localData.length == 1)&&(this.localData[0] == this.currentProductHandle)){
                    return;
                }

                this.classList.remove("hidden");
            }
        }

    }

    customElements.define(customElements.component, recentlyViewed);
}
  